import {
  ClipboardList,
  Trophy,
  Heart,
  Sliders,
  TrendingUp,
  BookOpen,
  Gauge,
  Wind,
  Crown,
  Sparkles,
  Scale,
  ShieldCheck,
  RotateCcw,
  Apple,
} from "lucide-react";

const features = [
  { icon: <ClipboardList className="w-5 h-5" />, title: "250+ Structured Programs", desc: "Phased plans with built-in progression — never random." },
  { icon: <Trophy className="w-5 h-5" />, title: "Sport-Specific Paths", desc: "Track & Field · Boxing · Basketball, programmed by sport." },
  { icon: <Heart className="w-5 h-5" />, title: "General Fitness & S&C", desc: "Fat loss, tone, strength, hypertrophy and performance." },
  { icon: <Sliders className="w-5 h-5" />, title: "Readiness-Based Adjustments", desc: "Workouts adapt to your daily No Fatigue Score." },
  { icon: <TrendingUp className="w-5 h-5" />, title: "Progress Dashboards & Charts", desc: "Logs, PRs and performance trends — at a glance." },
  { icon: <Scale className="w-5 h-5" />, title: "Body Composition & Assessments", desc: "Track body comp and complete performance assessments." },
  { icon: <BookOpen className="w-5 h-5" />, title: "200+ Exercise Library", desc: "Cues, demos and coaching notes for every movement." },
  { icon: <Wind className="w-5 h-5" />, title: "Mobility & Recovery", desc: "Built-in sessions to keep you healthy." },
  { icon: <Gauge className="w-5 h-5" />, title: "Monthly Performance Testing", desc: "Periodic testing prompts that drive your plan." },
  { icon: <Sparkles className="w-5 h-5" />, title: "AI Coach (Claude / GPT)", desc: "Personalized insights, programming context and answers." },
  { icon: <Crown className="w-5 h-5" />, title: "Elite KPIs & Coach Review", desc: "Sport KPI analytics, coach review & custom program (Elite)." },
  { icon: <Apple className="w-5 h-5" />, title: "Sign in with Apple · IAP", desc: "Private sign-in and secure native iOS subscriptions." },
  { icon: <ShieldCheck className="w-5 h-5" />, title: "Account Deletion & Privacy", desc: "Delete your account & data anytime in-app." },
  { icon: <RotateCcw className="w-5 h-5" />, title: "Restore Purchases", desc: "Easy restore across your Apple devices." },
];

export default function FeaturesSection() {
  return (
    <section
      id="features"
      className="relative nfp-section bg-[#070707]"
      data-testid="section-features"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#1FA2FF] mb-4">
              Features
            </p>
            <h2 className="nfp-heading text-white text-4xl md:text-6xl leading-[1] tracking-tight">
              Built for athletes. <br />
              Designed for <span className="text-white/30">everyone.</span>
            </h2>
          </div>
          <p className="md:max-w-sm text-white/60 leading-relaxed">
            Every capability engineered into a single performance training app —
            backed by a 250+ program library and 200+ exercise library.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-testid={`feature-${i}`}
              className="nfp-card p-6 flex items-start gap-4"
            >
              <div className="shrink-0 w-11 h-11 rounded-xl bg-[#1FA2FF]/10 border border-[#1FA2FF]/30 text-[#00E5FF] flex items-center justify-center">
                {f.icon}
              </div>
              <div>
                <h3 className="text-white font-semibold tracking-tight">{f.title}</h3>
                <p className="text-sm text-white/55 mt-1 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
